export default {
    accounts_tab_id: 'Id',
    accounts_tab_name: 'Nombre',
    accounts_tab_dealer: 'Distribuidor',
    accounts_tab_brand: 'Marca',
    accounts_tab_status: 'Estado',
    accounts_tab_companies: 'Compañias',
    accounts_tab_accounts: 'Cuentas',
    accounts_tab_advanced_filters: 'Filtros avanzados',
    accounts_tab_apply: 'Aplicar',
    accounts_tab_tags: 'Etiquetas',
    accounts_tab_active_accounts_only: 'Sólo cuentas activas',
    accounts_tab_yes: 'Si',
    accounts_tab_no: 'No',
    accounts_tab_authenticate_cloud: 'Iniciar sesión como cliente',
    accounts_tab_re_sync_backend_information: 'Re-sincronización de la información del backend',
    accounts_tab_devices: 'Dispositivos',
    accounts_tab_package: 'Paquete',
    accounts_tab_crm: 'Id. de Salesforce',
    accounts_tab_add_account: 'Agregar cuenta',
    accounts_tab_edit: 'Editar',
    accounts_tab_remove_filters: 'Eliminar los filtros',
    accounts_tab_account_details: 'Detalles de la cuenta',
    accounts_tab_import_from_p4: 'Importar desde P4',
    accounts_tab_reprocess_odo_hours: 'Reprocesar Odo/Hrs',
    accounts_tab_new_status: 'Nuevo Estado',
    accounts_tab_at: 'el',
    accounts_tab_next_scheduled_action: 'Próxima acción programada',
    accounts_tab_on: 'en'
};